import ScrubstrApiQueryService from '../ScrubstrApiQueryService/ScrubstrApiQueryService'

export type CustomizationStatus = 'not_proposed' | 'pending' | 'approved' | 'rejected' | null

export type PageCustomizationSnapshot = {
  name?: string | null
  imageUrl?: string | null
  city?: string | null
  state?: string | null
}

export interface ClaimedPage {
  id: number
  name: string
  city?: string | null
  state?: string | null
  claimId?: number
  claimRequestId?: number
  claimStatus?: 'pending' | 'approved' | 'denied' | 'withdrawn' | string
  customizationStatus?: CustomizationStatus
  customization?: PageCustomizationSnapshot | null
  requesterEmail?: string
  original?: {
    id: number
    name: string
    permalink?: string | null
    imageURL?: string | null
    averageRating?: number
    reviewCount?: number
    newReviewsThisMonth?: number
  } | null
}

export class ClaimedPagesService {
  async getMyPages(isAgency: boolean): Promise<ClaimedPage[]> {
    const api = new ScrubstrApiQueryService()
    const data = await api.get<ClaimedPage[]>({
      endpoint: 'claim-pages/my-pages',
      params: { isAgency: String(isAgency) },
    })
    return Array.isArray(data) ? data : []
  }
}
